import React from "react";
import MUIAvatar from "@mui/material/Avatar";
import sxStyles from "./Avatar.style";
const Avatar = ({ children }) => React.createElement(MUIAvatar, { sx: sxStyles.avatar }, children);
export default Avatar;
//# sourceMappingURL=Avatar.js.map